import {ProvidersIdsEnum} from '../../../../util/type';

import {FacebookAccountsMatching} from './facebook/facebook-accounts-matching';
import {GoogleAccountsMatching} from './google/google-accounts-matching';

type PropsType = {
    providerId: number;
    brandId: number;
};

export function MassAccountsMatchingContent(props: PropsType): JSX.Element {
    const {providerId, brandId} = props;

    switch (providerId) {
        case ProvidersIdsEnum.google: {
            return <GoogleAccountsMatching brandId={brandId} />;
        }
        case ProvidersIdsEnum.facebook: {
            return <FacebookAccountsMatching brandId={brandId} />;
        }
        default: {
            throw new Error('unsupported provider');
        }
    }
}
